import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertEdiStandardPayload, Maybe } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_EDI_STANDARD = gql`
    mutation upsertEdiStandard($input: UpsertEdiStandardInput!){
        upsertEdiStandard(input: $input){
            message
            errors {
                code
                message
            }
            result
        }
    }
`;

export const mutationUpsertEdiStandard = async (
    client: ApolloClient<NormalizedCacheObject>,
    options: {
        name?: string;
        description?: string;
        id?: Maybe<string>;
    }
): Promise<UpsertEdiStandardPayload | undefined> => {
    const { name, description, id } = options;
    const { data, errors } = await client.mutate<{ upsertEdiStandard: UpsertEdiStandardPayload }>({
        variables: { input: { name, description, id } },
        mutation: MUTATION_UPSERT_EDI_STANDARD
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the save of EDI Standard.');
    }
    if (data && data.upsertEdiStandard) {
        return data.upsertEdiStandard;
    }

    return undefined;
};